import React from "react";
import {FaCreditCard} from 'react-icons/fa'

const sublinks = [
  {
    page: "Categories",

    links: [
      { label: "Web development", icons:<FaCreditCard/>},

      { label: "Mobile development" },

      { label: "Game development" },

      { label: "Digital Marketing" },

      { label: "Business Analytics" },

      { label: "Entrepreneurship" },

      { label: "IT Certifications" },

      { label: "Graphic Design" },

      { label: "Personnal Transformation" },

      { label: "All Categories" },
    ],
  },

  {
    page: "Udemy Bunisness",

    links: [
      {
        label: "Get your team access to over",
      },
      {
        label: "19, 000 to Udemy Courses,",
      },
      {
        label: "anytime, anywhere.",
        button: "Try Udemy Business",
      },
    ],
  },
  {
    page: "Teach on Udemy",

    links: [
      {
        label: "Turn what you know into an",
      },
      {
        label: "opportunity and reach",
      },
      {
        label: "millions around the world",
        button: "Learn More",
      },
    ],
  },
];

export default sublinks;
